import message from "components/CustomMessage";
import { isEmpty } from "lodash";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { IntegrationType } from "views/Integrations/common";
import { getUrlSearch } from "utils/urlUtil";

export const nativeRedirectionSupportedTools = [
  "Checkmarx",
  "Snyk",
  "Edgescan",
  "Prisma Cloud Twistlock",
  "WhiteHat Sentinel",
];

export function fetchConfigAndRedirect({
  toolName,
  productName,
  subProductName,
  envName,
  operationalStatus,
}) {
  const closeMessage = message.loading("Pulling source details");
  ToolsIntegrationsAPI.getGenericEvolvedConfigurationsByToolName(toolName, {
    filters: {
      product_name: [productName],
      sub_product_name: [subProductName],
      environment: [envName],
      operationalStatus: operationalStatus ? [operationalStatus] : undefined,
    },
  })
    .promise.then((response) => {
      if (isEmpty(response.configurations)) {
        // message.warn("No config found.");
        window.open(`${window.location.origin}/#/security-tools/${toolName}`);
      } else {
        const config = response.configurations[0];
        const defaultActiveLoginConfigId = config.login_id;
        const defaultTab = defaultActiveLoginConfigId
          ? IntegrationType.PULL
          : config.webhookEnabled
          ? IntegrationType.WEBHOOK
          : IntegrationType.PUSH;

        window.open(`${window.location.origin}/#/security-tools/${toolName}?${getUrlSearch({
            filters: {
              defaultActiveLoginConfigId: [defaultActiveLoginConfigId],
              defaultTab: [defaultTab],
              defaultProductFilter: [productName],
              defaultSubproductFilter: [subProductName],
              defaultEnvironmentFilter: [envName],
              defaultOperationalStatusFilter: operationalStatus ? [operationalStatus] : undefined,
            }
        })}`);
      }
    })
    .finally(() => {
      closeMessage();
    });
}

const generarteNativeToolURL = (toolName, loginId, name, assetType = "", orgId = "", projectType= "") => {
  let URL = `/user/tools/generic/project/${toolName}/redirect?login_id=${loginId}&name=${name}`;
  if (assetType) {
    URL += `&assetType=${assetType}`;
  }
  if (orgId) {
    URL += `&orgId=${orgId}`;
  }
  if (projectType) {
    URL += `&projectType=${projectType}`;
  }
  return URL;
}

export const getNativeToolURL = (toolName, config) => {
  const defaultActiveLoginConfigId = config.login_id;
  let id, assetType, toolURL;

  switch (toolName) {
    case "Checkmarx":
      id = config.projectId ? config.projectId.split(",")[0] : config.id;
      toolURL = generarteNativeToolURL(toolName, defaultActiveLoginConfigId, id);
      break;
    case "Snyk":
      id = config.projectName ? config.projectName.split(",")[0].split(";")[0] : config.id;
      toolURL = generarteNativeToolURL(toolName, defaultActiveLoginConfigId, id, "", config.orgId, config.projectType);
      break;
    case "Edgescan":
      id = config.assetId ? config.assetId.split(",")[0] : config.id;
      toolURL = generarteNativeToolURL(toolName, defaultActiveLoginConfigId, id);
      break;
    case "Prisma Cloud Twistlock":
      if(!isEmpty(config.name)){
        id = config.name;
        assetType = config.type;
      }else if (!isEmpty(config.imageName)) {
        id = config.imageName.split(",")[0];
        assetType = "hosts/deployed";
      } else if (!isEmpty(config.registryName)) {
        id = config.registryName.split(",")[0];
        assetType = "images/registries";
      } else if (!isEmpty(config.ciImageName)) {
        id = config.ciImageName.split(",")[0];
        assetType = "images/ci";
      } else if (!isEmpty(config.codeRepoName)) {
        id = config.codeRepoName.split(",")[0];
        assetType = "code-security";
      } else if (!isEmpty(config.codeRepositoryId)) {
        id = config.codeRepositoryId.split(",")[0];
        assetType = "coderepos/repositories";
      }
      toolURL = generarteNativeToolURL(toolName, defaultActiveLoginConfigId, id, assetType);
      break;
    case "WhiteHat Sentinel":
      if(!isEmpty(config.id)){
        id = config.id;
        assetType = config.type;
      } else if (!isEmpty(config.applicationName)) {
        id = config.applicationName.split(",")[0];
        assetType = "application";
      } else if (!isEmpty(config.siteName)) {
        id = config.siteName.split(",")[0];
        assetType = "site";
      }
      toolURL = generarteNativeToolURL(toolName, defaultActiveLoginConfigId, id, assetType);
      break;
    default:
      console.warn("Unsupported tool name");
      break;
  }
  return toolURL;
}

export function fetchConfigAndRedirectToToolUI({
  toolName,
  productName,
  subProductName,
  envName,
  operationalStatus,
}) {
  const closeMessage = message.loading("Pulling source details");
  ToolsIntegrationsAPI.getGenericEvolvedConfigurationsByToolName(toolName, {
    filters: {
      product_name: [productName],
      sub_product_name: [subProductName],
      environment: [envName],
      operationalStatus: operationalStatus ? [operationalStatus] : undefined,
    },
  })
    .promise.then((response) => {
      if (isEmpty(response.configurations)) {
        message.warn("No config found.");
      } else {
        const config = response.configurations[0];
        if (config.login_id) {
          const toolURL = getNativeToolURL(toolName, config);
          window.open(toolURL, "_blank");
        } else {
          message.warn("No config found.");
        }
      }
    })
    .finally(() => {
      closeMessage();
    });
}
